module.exports = __webpack_public_path__ + "img/cvsaya.b14e027b.png";